import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import { isNil } from 'vdlib';

const colorClassNames = ['blue', 'red', 'green', 'purple'];

const defaults = {
  colorClassName: colorClassNames[0],
  icon: '',
};

class Counter extends React.Component {
  render() {
    var value =
      this.props.value instanceof Date
        ? this.props.value.toLocaleDateString()
        : this.props.value;
    return (
      <div
        className={`counter-container ${this.props.containerClassName || ''}`}
      >
        <div
          className={
            'dashboard-stat dashboard-stat-v2 ' +
            (this.props.colorClassName || defaults.colorClassName)
          }
        >
          <div className="visual">
            <i className={'fa fa-' + this.props.icon} />
          </div>
          <div className="details">
            <div className="number">
              <span data-counter="counterup" data-value={value}>
                {' '}
                {value}
              </span>
            </div>
            <div className="desc">{this.props.title} </div>
            {isNil(this.props.amount) ? (
              false
            ) : (
              <div className="desc">
                {' '}
                <span fontSize="small">
                  {I.t('AMOUNT')} {this.props.amount}
                </span>{' '}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Counter.propTypes = {
  colorClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.any,
  amount: PropTypes.any,
};

export default Counter;
